import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import { Button, ButtonProps, Stack, Typography } from "@mui/material";
import { useController, UseControllerProps } from "react-hook-form";
import { ReactNode } from "react";
import { useTranslations } from "next-intl";

export interface FormButtonSelectProps<T> extends UseControllerProps {
  options: T[];

  getLabel?(value: T): ReactNode;

  getKey?(value: T): string;

  onClick?(value: T): void;

  variant?: ButtonProps["variant"];
  variantSelected?: ButtonProps["variant"];
}

export const FormButtonSelect = <T,>({
  options,
  getLabel = (o) => `${o}`,
  getKey = (o) => `${o}`,
  variant = "outlined",
  variantSelected = "contained",
  onClick,
  ...props
}: FormButtonSelectProps<T>) => {
  const {
    field: { onChange, value, disabled },
    fieldState,
  } = useController(props);

  const t = useTranslations();

  return (
    <>
      <Stack gap={1}>
        {options.map((o) => {
          const isSelected = !!value && getKey(value) === getKey(o);
          return (
            <Button
              key={getKey(o)}
              variant={isSelected ? variantSelected : variant}
              disabled={disabled}
              endIcon={
                isSelected ? (
                  <CheckBoxIcon color="primary" />
                ) : (
                  <CheckBoxOutlineBlankIcon />
                )
              }
              onClick={() => {
                if (isSelected) {
                  onChange(undefined);
                } else {
                  onChange(o);
                }
                onClick?.(o);
              }}
              sx={{ p: 2, borderColor: "primary" }}
            >
              <Typography flexGrow={1}>{getLabel(o)}</Typography>
            </Button>
          );
        })}
        {fieldState.error && (
          <Typography color="error">
            {t(fieldState.error.message ?? "")}
          </Typography>
        )}
      </Stack>
    </>
  );
};
